import React from 'react';
import './CarModelScrollFixedImages.scss';
import { Image } from '@sitecore-jss/sitecore-jss-react';

export default function ScrollFixedImages({ scrollingSlidesJaecooJ7Phev }) {
  return (
    <div className={'wrapper-scroll-img'} data-aos="fade-up">
      {scrollingSlidesJaecooJ7Phev.map((item) => {
        return (
          <div key={item.fields.id.value} className={'imageWrapper'}>
            <div className={'item'}>
              <Image field={item?.fields?.image} alt={item?.fields?.title?.value} fill />
              <div className={'item_text'}>
                <p>{item?.fields?.title?.value}</p>
                <p className={'item_text_content'}>{item?.fields?.text?.value}</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
